import React from 'react';

import useScrollTrigger from '@mui/material/useScrollTrigger';

export type ElevationScrollProps = {
  children: React.ReactElement;
};

export function ElevationScroll(props: ElevationScrollProps): JSX.Element {
  const { children } = props;
  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 0,
  });

  return React.cloneElement(children, {
    elevation: trigger ? 2 : 0,
  });
}

export default ElevationScroll;
